import addr from '@/assets/data/data'
import {isEmpty} from "@/api/validator";

/**
 * 根据县区ID获取省DI
 * @param subCode
 */
export function getProvinceIdByAreaId(subCode) {
  const areaIdStr = subCode.toString();
  return areaIdStr.substring(0, 2);
}

/**
 * 根据县区ID获取市ID
 * @param subCode
 */
export function getCityIdByAreaId(subCode) {
  const areaIdStr = subCode.toString();
  return areaIdStr.substring(0, 4);
}

/**
 * 根据市ID获取省DI
 * @param subCode
 */
export function getProvinceIdByCityId(cityCode) {
  const provIdStr = cityCode.toString();
  return provIdStr.substring(0, 2);
}

/**
 * 根据地市ID获取省、市、区空格分开的地址
 * @param subCode
 */
export function getAddrStrByAreaId(subCode) {
  const areaIdStr = subCode.toString();

  if(areaIdStr === "000000"){
    return "【下载】后查看"
  }

  if (areaIdStr != null && areaIdStr != '' && areaIdStr.length == 6) {
    const prov = areaIdStr.substring(0, 2);
    const city = areaIdStr.substring(0, 4);
    let provName = ''
    let cityName = ''
    let areaName = ''
    for (let i = 0; i < addr.length; i++) {
      const ps = addr[i]
      if (ps.id == prov) {
        const citys = ps.children
        provName = ps.value
        for (let j = 0; j < citys.length; j++) {
          const ct = citys[j]
          if (ct.id == city) {
            cityName = ct.value
            const areas = ct.children
            for (let k = 0; k < areas.length; k++) {
              const as = areas[k]
              if (as.id == areaIdStr) {
                areaName = as.value
                break
              }
            }
            break
          }
        }
        break
      }
    }
    return provName + ' ' + cityName + ' ' + areaName;
  } else {
    return "";
  }
}

/**
 * 根据地市ID获取省、市、区空格分开的地址
 * @param subCode
 */
export function getProAndCity(subCode) {
  const areaIdStr = subCode.toString();
  if (areaIdStr != null && areaIdStr != '' && areaIdStr.length == 6) {
    const prov = areaIdStr.substring(0, 2);
    const city = areaIdStr.substring(0, 4);
    let provName = ''
    let cityName = ''
    let areaName = ''
    for (let i = 0; i < addr.length; i++) {
      const ps = addr[i]
      if (ps.id == prov) {
        const citys = ps.children
        provName = ps.value
        for (let j = 0; j < citys.length; j++) {
          const ct = citys[j]
          if (ct.id == city) {
            cityName = ct.value
            const areas = ct.children
            for (let k = 0; k < areas.length; k++) {
              const as = areas[k]
              if (as.id == areaIdStr) {
                areaName = as.value
                break
              }
            }
            break
          }
        }
        break
      }
    }
    return provName + ' - ' + cityName;
  } else {
    return "";
  }
}

/**
 * 根据地址ID获取地址，用空格分开
 * @param subCode
 */
export function getAddrStrByAddrId(addrId) {
  const areaIdStr = addrId.toString();
  if (!isEmpty(areaIdStr)) {
    let provName = ''
    let cityName = ''
    let areaName = ''
    if (areaIdStr.length == 6) {
      const prov = areaIdStr.substring(0, 2);
      const city = areaIdStr.substring(0, 4);
      for (let i = 0; i < addr.length; i++) {
        const ps = addr[i]
        if (ps.id == prov) {
          const citys = ps.children
          provName = ps.value
          for (let j = 0; j < citys.length; j++) {
            const ct = citys[j]
            if (ct.id == city) {
              cityName = ct.value
              const areas = ct.children
              for (let k = 0; k < areas.length; k++) {
                const as = areas[k]
                if (as.id == areaIdStr) {
                  areaName = as.value
                  break
                }
              }
              break
            }
          }
          break
        }
      }
      return provName + ' ' + cityName + ' ' + areaName;
    }else if(areaIdStr.length == 4){
      const prov = areaIdStr.substring(0, 2);
      const city = areaIdStr;
      for (let i = 0; i < addr.length; i++) {
        const ps = addr[i]
        if (ps.id == prov) {
          const citys = ps.children
          provName = ps.value
          for (let j = 0; j < citys.length; j++) {
            const ct = citys[j]
            if (ct.id == city) {
              cityName = ct.value
              break
            }
          }
          break
        }
      }
      return provName + ' ' + cityName;
    }else {
      const prov = areaIdStr;
      for (let i = 0; i < addr.length; i++) {
        const ps = addr[i]
        if (ps.id == prov) {
          provName = ps.value
          break
        }
      }
      return provName;
    }
  } else {
    return "";
  }
}



// WEBPACK FOOTER //
// ./src/api/addr.js